import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfirmationService, ModalService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../../models/enums.generated';
import { camps } from '../../../../../models/models.generated';
import { CampCareApiService } from '../../../../../services/api/camp-care-api.service';
import { CampsDetailsFormStateService } from '../../camp-details-form-state-service';
import { CampCareDaySingleEditComponent } from '../camp-care-day-single-edit/camp-care-day-single-edit.component';
import { CampsEnumTranslationService } from '../../../../../services/camps-enum-translation.service';

@Component({
    selector: 'app-camp-care-days-list',
    templateUrl: './camp-care-days-list.component.html',
    styleUrls: ['./camp-care-days-list.component.scss'],
    standalone: false
})
export class CampCareDaysListComponent implements OnInit {
    @Input()
    public campForm: UntypedFormGroup;
    @Input()
    public campCare: camps.CampCareDetails;

    constructor(
        private campCareApi: CampCareApiService,
        private modal: ModalService,
        private confirmation: ConfirmationService,
        private translate: TranslateService,
        private alert: BayclubsAlertService,
        private state: CampsDetailsFormStateService,
        public enumTranslate: CampsEnumTranslationService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {}

    public isArchived(item: camps.CampCareDayInfo) {
        return item.status == campsenum.CampCareDayStatus.Archived;
    }

    public edit(item: camps.CampCareDayInfo, group: camps.CampCareDaysInClubs): void {
        this.modal
            .create<CampCareDaySingleEditComponent>(CampCareDaySingleEditComponent, { campForm: this.campForm, editItem: item })
            .subscribe(component => {
                if (component.result) {
                    this.updateOnList(item, group, component.result);
                }
            });
    }

    public activate(item: camps.CampCareDayInfo, group: camps.CampCareDaysInClubs): void {
        this.confirmation.show(null, this.translate.instant('CampCareList.ActivateConfirmation')).subscribe(result => {
            if (result === true) {
                this.campCareApi
                    .activateDay(<camps.CampCareDayActivateRequest>{
                        campCareDayId: item.id
                    })
                    .subscribe(result => {
                        if (result.isSuccess) {
                            this.updateOnList(item, group, result.value);
                            this.alert.showOperationSuccess();
                        } else {
                            this.errorTranslate.translateValidationNotifications(result.validationNotification);
                            this.alert.showError(result.validationNotification.errors[0].message);
                        }
                    });
            }
        });
    }

    public archive(item: camps.CampCareDayInfo, group: camps.CampCareDaysInClubs): void {
        this.confirmation.show(null, this.translate.instant('CampCareList.ArchiveConfirmation')).subscribe(result => {
            if (result === true) {
                this.campCareApi
                    .archiveDay(<camps.CampCareDayActivateRequest>{
                        campCareDayId: item.id
                    })
                    .subscribe(result => {
                        if (result.isSuccess) {
                            this.updateOnList(item, group, result.value);
                            this.alert.showOperationSuccess();
                        } else {
                            this.errorTranslate.translateValidationNotifications(result.validationNotification);
                            this.alert.showError(result.validationNotification.errors[0].message);
                        }
                    });
            }
        });
    }

    public canEdit(item: camps.CampCareDayInfo): Observable<boolean> {
        return this.state.canEditCampCare.pipe(
            map(
                canEditCampCare =>
                    (this.isArchived(item) || this.campCare.status != campsenum.CampCareStatus.Active) && canEditCampCare
            )
        );
    }

    public canActivate(item: camps.CampCareDayInfo): Observable<boolean> {
        return this.state.canEditCampCare.pipe(map(canEditCampCare => this.isArchived(item) && canEditCampCare));
    }

    public canArchive(item: camps.CampCareDayInfo): Observable<boolean> {
        return this.state.canEditCampCare.pipe(map(canEditCampCare => !this.isArchived(item) && canEditCampCare));
    }

    public updateOnList(source: camps.CampCareDayInfo, group: camps.CampCareDaysInClubs, result) {
        var groupIdx = this.campCare.campCareDaysInClubs.indexOf(group);
        if (groupIdx > -1) {
            var itemIdx = this.campCare.campCareDaysInClubs[groupIdx].campCareDays.indexOf(source);
            if (itemIdx > -1) {
                this.campCare.campCareDaysInClubs[groupIdx].campCareDays[itemIdx] = result;
            }
        }
    }
}
